/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PaymentStatus {
  PAID = 'paid',
  CANCELLED = 'cancelled',
  FAILED = 'failed',
}
